import React from 'react'

import { Select } from 'slab'

import { type DropdownOption } from './types'

interface ReimbursementFromDropdownProps {
  error?: React.ReactNode;
  value: string | null
  onChange: React.Dispatch<React.SetStateAction<string>> | ((v: string) => void)
  dropdownOptions: DropdownOption[]
  label: string
}

export const ReimbursementFormDropdown: React.FC<ReimbursementFromDropdownProps> = ({ error, value, onChange, dropdownOptions, label }) => {
  return (
    <Select
      error={error}
      label={label}
      placeholder='Select'
      onChange={(e) => onChange(e.target.value)}
      value={value ?? ''}
    >
      {dropdownOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
}
